import { gql } from '@/shared/graphql/generated/explorer';
import { type ExtrinsicFragment } from '@/shared/graphql/generated/explorer/graphql';
import { type TokenCast } from '@/shared/utils/TokenAmount';

export const getExtrinsicsAndEventsByBlockId = gql(/* GraphQL */ `
  query getExtrinsicsAndEventsByBlockId($blockId: Int!) {
    details: getBlockDetails(blockHeight: $blockId) {
      extrinsics {
        callName
        callOrigin
        hash
        indexInBlock
        callArgs
      }
      events {
        indexInBlock
        extrinsicHash
        name
      }
    }
    block: blockById(id: $blockId) {
      timestamp
    }
  }
`);

gql(/* GraphQL */ `
  fragment Extrinsic on Extrinsic {
    id
    fee
    hash
    blockId
    indexInBlock
    signature
    success
    tip
    account: accountBySubmitterId {
      id
      idSs58
      alias
    }
    block: blockByBlockId {
      id
      hash
      timestamp
    }
    metadata: metadatumByMetadataId {
      id
      name
      label
    }
  }
`);

export const extrinsicCastFields = ['fee', 'tip'] as const;
export type CastExtrinsicFragment = TokenCast<
  ExtrinsicFragment,
  (typeof extrinsicCastFields)[number]
>;

export const getExtrinsicsByAccountQuery = gql(/* GraphQL */ `
  query getExtrinsicsByAccount(
    $accountIds: [String!]!
    $first: Int
    $last: Int
    $after: Cursor
    $before: Cursor
  ) {
    extrinsics: allExtrinsics(
      filter: { accountBySubmitterId: { idSs58: { in: $accountIds } } }
      orderBy: ID_DESC
      after: $after
      before: $before
      first: $first
      last: $last
    ) {
      pageInfo {
        hasPreviousPage
        startCursor
        hasNextPage
        endCursor
      }
      edges {
        node {
          ...Extrinsic
        }
      }
      # totalCount
    }
  }
`);
